// feature/hli-client-stripe | Aug 9th 2026: "Select all"/"Deselect all" buttons for a native
// <select multiple> - ctrl/cmd+click and shift+click range-select already work natively via the
// browser, this only adds the two buttons on top.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  selectAll() {
    this.setAllSelected(true)
  }

  deselectAll() {
    this.setAllSelected(false)
  }

  setAllSelected(selected) {
    Array.from(this.selectTarget.options).forEach((option) => {
      option.selected = selected
    })

    // Clicking the button moves focus off the <select>, and an unfocused <select multiple>
    // renders selected options in a muted grey instead of blue - refocus it so the change is
    // actually visible, not just applied.
    this.selectTarget.focus()
  }
}
